module.exports = __webpack_public_path__ + "img/x_white.09e32c5c.svg";